module.exports = __webpack_public_path__ + "img/terroir-3.bb37cd11.jpg";